// Vendor
import React from 'react'
import { defineMessages } from 'react-intl'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'

// WeSpire
import { GroupCard } from './group_card'
import { Heading } from 'components/ui/heading'
import { intl } from 'utilities/localization'
import { MissingResourceSection } from 'components/ui/missing_resource_section'
import { SkeletonLoading } from 'components/ui/skeleton_loading'
import { sortByNumber } from 'utilities/sort'
import Stack from 'components/ui/stack'
import WeQuery from 'components/application/we_query'

const messages = defineMessages({
  noGroupsJoined: {
    defaultMessage:
      'It looks like you have not joined any groups yet. Join one of the {friendlyErgName} below.',
    id: 'moreGroups.noGroupsJoined',
  },
  yourGroups: {
    defaultMessage: 'Your {friendlyErgName}',
    id: 'moreGroups.yourGroups',
  },
})
const { formatMessage } = intl

const userGroupQuery = gql`
  query UserGroupsQuery($groupFilter: String) {
    groups(groupFilter: $groupFilter) {
      descriptionPlainText
      heroImage
      id
      name
      position
      userGroupChapter {
        descriptionPlainText
        id
        name
        slug
      }
      slug
    }
  }
`

const UserGroups = ({ friendlyErgName }) => {
  return (
    <Stack as="section">
      <Heading className="px-2" data-test="your-groups-heading" level={2}>
        {formatMessage(messages.yourGroups, {
          friendlyErgName,
        })}
      </Heading>
      <WeQuery
        error={
          <MissingResourceSection
            errorDetails={formatMessage(messages.yourGroups, {
              friendlyErgName,
            })}
          />
        }
        loader={<SkeletonLoading height={245} />}
        query={userGroupQuery}
        variables={{ groupFilter: 'userGroups' }}
      >
        {({ data: { groups } }) => {
          const sortedGroups = sortByNumber(groups, 'position')

          return (
            <>
              {sortedGroups.length ? (
                <ul
                  className="[ row vertical-gutters ] [ pb-3 px-0 ]"
                  data-test="your-groups"
                >
                  {sortedGroups.map((group) => (
                    <GroupCard
                      chapter={group.userGroupChapter}
                      group={group}
                      key={group.id}
                    />
                  ))}
                </ul>
              ) : (
                <p className="py-3" data-test="your-groups-empty-state-message">
                  {formatMessage(messages.noGroupsJoined, {
                    friendlyErgName,
                  })}
                </p>
              )}
            </>
          )
        }}
      </WeQuery>
    </Stack>
  )
}

UserGroups.propTypes = {
  friendlyErgName: PropTypes.string.isRequired,
}

export { UserGroups, userGroupQuery }
